/**
 * Números de página visibles con elipsis (ej. 1 … 4 5 6 … 18).
 * @param {number} currentPage - 1-based
 * @param {number} totalPages - >= 1
 * @param {number} delta - vecinos a cada lado de la página actual (por defecto 1)
 * @returns {(number|string)[]} números o la cadena 'ellipsis'
 */
export function getVisiblePageNumbers(currentPage, totalPages, delta = 1) {
    if (!totalPages || totalPages < 1) return [];
    if (totalPages === 1) return [1];

    const showAllThreshold = 7 + delta * 2;
    if (totalPages <= showAllThreshold) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages = [];
    const left = Math.max(2, currentPage - delta);
    const right = Math.min(totalPages - 1, currentPage + delta);

    pages.push(1);
    if (left > 2) pages.push('ellipsis');
    for (let i = left; i <= right; i += 1) pages.push(i);
    if (right < totalPages - 1) pages.push('ellipsis');
    pages.push(totalPages);
    return pages;
}
